import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
import "../../styles/all.css"
import "../../styles/theme.css"
import "./team.css"
function Team(){
    return(
        <>
        <div className="team">
             <div className="start">
                <h4>Team Progress</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="content">
                <div className="cardd">
                    <div className="info">
                        <div className="image">
                            <img src={personone} alt="" />
                        </div>
                        <div className="text">
                            <h5>Omar Rehan</h5>
                            <h6>Front End Developer</h6>
                        </div>

                    </div>
                     <div className="prcentage">
                        <div className="one"></div>

                    </div>
    

                </div>
                <div className="cardd">
                    <div className="info">
                        <div className="image">
                            <img src={persontwo} alt="" />
                        </div>
                        <div className="text">
                            <h5>Ahmed Rehan</h5>
                            <h6>BackEnd Developer Developer</h6>
                        </div>

                    </div>
                     <div className="prcentage">
                        <div className="two"></div>

                    </div>
    

                </div>
                <div className="cardd">
                    <div className="info">
                        <div className="image">
                            <img src={personthree} alt="" />
                        </div>
                        <div className="text">
                            <h5>Alison Maker</h5>
                            <h6>Flutter Developer</h6>
                        </div>

                    </div>
                     <div className="prcentage">
                        <div className="three"></div>

                    </div>
    

                </div>
                <div className="cardd">
                    <div className="info">
                        <div className="image">
                            <img src={personfour} alt="" />
                        </div>
                        <div className="text">
                            <h5>Mike Tayson</h5>
                            <h6>Mobile Applaction </h6>
                        </div>

                    </div>
                     <div className="prcentage">
                        <div className="four"></div>

                    </div>
    

                </div>
                 <div className="cardd">
                    <div className="info">
                        <div className="image">
                            <img src={personfive} alt="" />
                        </div>
                        <div className="text">
                            <h5>Mike Enderson</h5>
                            <h6>Full Stack Developer </h6>
                        </div>

                    </div>
                     <div className="prcentage">
                        <div className="five"></div>

                    </div>
    

                </div>

            </div>
        </div>
        </>
    )
}
export default Team